import {atom} from 'recoil';

import {ICompany} from '../../shared/types/company.types';
import {IPageableDto, IPageableTable} from '../../shared/types/pageable.types';
import {getEmptyPage} from '../../shared/helpers/getEmptyPage';

export const companiesQueryTrigger = atom<number>({
  key: 'companiesQueryTrigger',
  default: 0,
});

export const companiesState = atom<IPageableDto<ICompany>>({
  key: 'companiesState',
  default: getEmptyPage<ICompany>(),
});

export const companiesForMapState = atom<ICompany[]>({
  key: 'companiesForMapState',
  default: [],
});

export const currentCompanyIdState = atom<string>({
  key: 'currentCompanyIdState',
  default: '',
});

export const createdCompanyState = atom<ICompany | null>({
  key: 'createdCompanyState',
  default: null,
});

export const selectedCompaniesState = atom<string[]>({
  key: 'selectedCompaniesState',
  default: [],
});

export const currentCompanyState = atom<ICompany | null>({
  key: 'currentCompanyState',
  default: null,
});

export const companyPageable = atom<IPageableTable>({
  key: 'companyPageable',
  default: {
    page: 0,
    size: localStorage.getItem('companiesPerPage')
      ? parseInt(localStorage.getItem('companiesPerPage') as string, 10)
      : 5,
  },
});

export const companiesForMapQueryTrigger = atom<number>({
  key: 'companiesForMapQueryTrigger',
  default: 0,
});

export const mapWithCompanyNamesState = atom({
  key: 'mapWithCompanyNamesState',
  default: new Map(),
});

export const companiesSortQueryTrigger = atom<{field: string; sort: 'asc' | 'desc' | null | undefined}[]>({
  key: 'companiesSortQueryTrigger',
  default: [],
});

export const companiesFilterQueryTrigger = atom<Record<string, string> | null>({
  key: 'companiesFilterQueryTrigger',
  default: null,
});

export const companiesSelectedState = atom<{
  [key: number]: string[];
}>({
  key: 'companiesSelectedState',
  default: {
    0: [],
  },
});
